import app from "../main";
import appHelper from "./app_helper";
import objectHelper from "./object_helper";

const dialogHelper = {
    confirm: async function (message, options = {}) {
        options = objectHelper.mergeTo(options, {
            title: appHelper.settings.applicationName,
            showCancelButton: true,
            confirmButtonText: app.$t('Accept'),
            cancelButtonText: app.$t('Cancel'),
            html: app.$t(message)
        });

        let result = await app.$swal(options);
        return result.isConfirmed;
    },
    alert: function (message, type = null, options = {}) {
        options = objectHelper.mergeTo(options, {
            title: appHelper.settings.applicationName,
            icon: type,
            confirmButtonText: app.$t('Accept'),
            html: app.$t(message)
        });

        app.$swal(options);
    }
}

export default dialogHelper;